import { useMemo } from "react";

import { SelectOption } from "components/forms";
import { useAccountSelector } from "store";
import { normalizeGroupByCharacteristic } from "utils";

import { useCharacteristics } from "./use-characteristics";

type Options = {
  includeInvestorGroups?: boolean;
  includeDealGroups?: boolean;
  includeMeasureGroups?: boolean;
  includeDateGroups?: boolean;
};

/** Same group-by choices as ReportMeasuresTable / Timeline toolbar. */
export function useReportMeasuresGroupByOptions(options?: Options): SelectOption[] {
  const characteristicsAll = useCharacteristics();
  const { support_investor_groups } = useAccountSelector() || {};

  const {
    includeInvestorGroups = true,
    includeDealGroups = true,
    includeMeasureGroups = true,
    includeDateGroups = true
  } = options ?? {};

  return useMemo(
    () => [
      ...(includeInvestorGroups ? [{ text: "Investor", key: "Investor", value: "investor" }] : []),
      ...(includeInvestorGroups && support_investor_groups
        ? [{ text: "Investor Group", key: "Investor Group", value: "investorGroup" }]
        : []),
      ...(includeDealGroups ? [{ text: "Deal", key: "Deal", value: "deal" }] : []),
      ...(includeMeasureGroups ? [{ text: "Measure", key: "Measure", value: "measure" }] : []),
      ...(includeDateGroups ? [{ text: "Date - month", key: "month", value: "month" }] : []),
      ...(includeDateGroups ? [{ text: "Date - quarter", key: "quarter", value: "quarter" }] : []),
      ...(includeDateGroups ? [{ text: "Date - year", key: "year", value: "year" }] : []),
      ...characteristicsAll.map((char) =>
        typeof char === "string" ? { text: char, key: char, value: normalizeGroupByCharacteristic(char) } : char
      )
    ],
    [
      characteristicsAll,
      support_investor_groups,
      includeInvestorGroups,
      includeDealGroups,
      includeMeasureGroups,
      includeDateGroups
    ]
  );
}
